import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper/types';
import 'swiper/css';

import { NavLink } from 'react-router-dom';
import { isTspPortal } from '../../utils/validUtil';
const agencies = [
  { page: 'http://aica-gj.kr', nm: '사업단대표홈페이지' },
  { page: 'http://www.gwangju.go.kr', nm: '광주광역시' },
  { page: 'http://nipa.kr', nm: '정보통신산업진흥원' },
  { page: 'http://msit.go.kr', nm: '과학기술정보통신부' },
];

function Footer() {
  // SwiperCore 타입으로 useRef 선언
  const swiperRef = useRef<any>(null);

  useEffect(() => {
    if (!swiperRef.current) return;

    const observer = new ResizeObserver(() => {
      swiperRef.current.update();
    });

    const target = document.querySelector('.familysite-area');
    if (target) observer.observe(target);

    return () => observer.disconnect();
  }, []);

  const [isPlaying, setIsPlaying] = useState(true);

  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  const handlePlay = () => {
    swiperRef.current?.autoplay.start();
    setIsPlaying(true);
  };

  const handlePause = () => {
    swiperRef.current?.autoplay.stop();
    setIsPlaying(false);
  };

  const familySites = [
    {
      href: 'https://www.aica-gj.kr/main.php',
      title: 'AICA 사이트 새 창 열림',
      img: `${process.env.PUBLIC_URL}/image/logo-aica.svg`,
    },
    {
      href: 'https://www.gwangju.go.kr/main.do',
      title: '광주광역시 사이트 새 창 열림',
      img: `${process.env.PUBLIC_URL}/image/logo-gwangju.svg`,
    },
    {
      href: 'https://www.nipa.kr',
      title: 'NIPA 사이트 새 창 열림',
      img: `${process.env.PUBLIC_URL}/image/logo-nipa.svg`,
    },
    {
      href: 'https://www.msit.go.kr/index.do',
      title: '과학기술정보통신부 사이트 새 창 열림',
      img: `${process.env.PUBLIC_URL}/image/logo-msit.svg`,
    }
  ];

  const slides = [...familySites, ...familySites];

  return (
    <>
      <div className='familysite-area'>
        <div className='container'>
          <div className='familysite-left'>
            <strong>유관사이트</strong>
            <div className='familysite-control'>
              <button type='button' title='이전 슬라이드' className='familysite-btn' onClick={handlePrev}><i className='icon icon-prev'></i></button>
              {isPlaying ? (
                <button type='button' title='슬라이드 일시정지' className='familysite-btn' onClick={handlePause}><i className='icon icon-pause'></i></button>
              ) : (
                <button type='button' title='슬라이드 재생' className='familysite-btn' onClick={handlePlay}><i className='icon icon-play'></i></button>
              )}
              <button type='button' title='다음 슬라이드' className='familysite-btn' onClick={handleNext}><i className='icon icon-next'></i></button>
            </div>
          </div>
          <div className='familysite-w'>
            <Swiper
              modules={[Autoplay]}
              onSwiper={(swiper: SwiperType) => (swiperRef.current = swiper)}
              slidesPerView={4}
              spaceBetween={20}
              loop
              breakpoints={{
                0: {
                  slidesPerView: 3,
                },
                1029: {
                  slidesPerView: 4,
                },
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
            >
              {slides.map((site, idx) => (
                <SwiperSlide key={idx}>
                  <a
                    href={site.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={site.title}
                    className='familysite'
                  >
                    <img src={site.img} alt={site.title} />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      <footer className='footer'>
        <div className='footer-head'>
          <div className='container'>
            <div className='footer-inner'>
              <ul className='footer-link-w'>
                <li>
                  <a
                    href="javascript:void(0);"
                    className="footer-link mint"
                    onClick={() => {
                      const domain = process.env.REACT_APP_DOMAIN;
                      window.location.href = `${domain}/information?preUrl=${window.btoa(
                        window.location.href
                      )}`;
                    }}
                  >개인정보처리방침</a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    className="footer-link"
                    onClick={() => {
                      const domain = process.env.REACT_APP_DOMAIN;
                      window.location.href = `${domain}/TosContent?preUrl=${window.btoa(
                        window.location.href
                      )}`;
                    }}
                  >이용약관</a>
                </li>
                <li>
                  <NavLink
                    to={
                      isTspPortal
                        ? '/tsp/About/FAQ'
                        : '/SupportForUse/FrequentlyAskedQuestions'
                    }
                    replace
                    className="footer-link"
                  >
                    자주묻는질문
                  </NavLink>
                </li>
                <li className="menual-btn-w">
                  <a
                    href="#user-manual"
                    className="footer-link"
                    onClick={(e) => {
                      e.preventDefault();
                      document.documentElement.classList.add('menual-active');
                    }}
                  >
                    사용자매뉴얼
                  </a>
                </li>
              </ul>
            </div>
            <select className='mo-familysite' title='유관기관 바로가기' aria-label="유관기관 바로가기">
              <option selected hidden disabled>유관기관 바로가기</option>
              <option>AICA</option>
              <option>광주광역시</option>
              <option>NIPA</option>
              <option>과학기술정보통신부</option>
            </select>
          </div>
        </div>
        <div className='footer-body'>
          <div className='container'>
            <div className='footer-inner'>
              <div className='footer-info-w'>
                <div className='logo-common'><span className='ir'>인공지능산업융단사업단 로고</span></div>
                <div className='footer-info'>
                  <p>주소 : 광주광역시 북구 오룡동 1013</p>
                  <p>대표번호 : TEL. 062-610-3900</p>
                  <p>장애문의 : TEL. 062-610-3919</p>
                </div>
                <p className='footer-copyright'>Copyrightⓒ 2026 AICA. All rights reserved</p>
              </div>
              <div className='footer-sns-w'>
                <a href='https://www.instagram.com/aica_gwangju/' aria-label='인공지능산업융단사업단 인스타그램 새 창 열림' target='_blank' rel='noopener noreferrer' className='footer-sns'>
                  <i className='icon icon-instar' aria-hidden='true'></i>
                  <span className='ir'>인공지능산업융단사업단 인스타그램 새 창 열림</span>
                </a>
                <a href='https://www.youtube.com/channel/UCC5t5AArvuZ7weH_a8VuFNg' aria-label='인공지능산업융단사업단 유튜브 새 창 열림' target='_blank' rel='noopener noreferrer' className='footer-sns'>
                  <i className='icon icon-youtube' aria-hidden='true'></i>
                  <span className='ir'>인공지능산업융단사업단 유튜브 새 창 열림</span>
                </a>
                <a href='https://www.facebook.com/aicongwangju/' aria-label='인공지능산업융단사업단 페이스북 새 창 열림' target='_blank' rel='noopener noreferrer' className='footer-sns'>
                  <i className='icon icon-facebook' aria-hidden='true'></i>
                  <span className='ir'>인공지능산업융단사업단 페이스북 새 창 열림</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
